import { AxiosInstance } from 'axios';
import { ApiService } from '../model/Api.model';
import { IToggleAccrualRequest } from '../interface/trade/post-purchase/request/IToggleAccrualRequest';

enum AccrualServiceEnum {
  toggle = "/toggle",
}

export class AccrualService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/accrual");
  }

  public getByTradeId = (tradeId: number): Promise<IToggleAccrualRequest> => this.GET(`${AccrualServiceEnum.toggle}?tradeId=${tradeId}`);
  public toggleAccrual = (toggleAccrualRequest: IToggleAccrualRequest): Promise<void> => this.POST(AccrualServiceEnum.toggle, toggleAccrualRequest);
}